module.exports = __webpack_public_path__ + "static/media/tie_red.946ef909.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tie_red.png
// module id = 130
// module chunks = 0